import React from 'react';
import { TruckFilters } from '../../../app/models/Truck';

type Props = {
    filter: TruckFilters;
    setFilter: (filter: TruckFilters) => void;
};

const TruckFilter = ({ filter, setFilter }: Props) => {
    const handlerInputFilter = (e: React.ChangeEvent<HTMLInputElement>) => {
        setFilter({
            ...filter,
            [e.target.name]: e.target.value
        });
    };

    const handlerSelectFilter = (e: React.ChangeEvent<HTMLInputElement>) => {
        setFilter({
            ...filter,
            [e.target.name]: e.target.value
        });
    };

    return (
        <div className="row">
            <div className="col-md-auto">
                <div className="mb-3">
                    <label className="font-size-10 mb-1" htmlFor="patent">
                        Patente
                    </label>
                    <input
                        type="text"
                        id="patent"
                        name="patent"
                        className="form-control form-control-sm"
                        value={filter.patent}
                        onChange={(e) => handlerInputFilter(e)}
                    />
                </div>
            </div>
        </div>
    );
};

export default TruckFilter;
